// ** Redux Imports
import { combineReducers } from 'redux';

// ** Reducers Imports
import auth from './auth';
import layout from './layout';
import components from './components';
import adminReducer from './admin';
import merchantReducer from './merchant';
import commonReducer from './common';
import driverReducer from './driver';

const rootReducer = combineReducers({
  auth,
  layout,
  components,
  admin: adminReducer,
  merchant: merchantReducer,
  common: commonReducer,
  driver: driverReducer,
});

export default rootReducer;
